import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { ConfirmationModal } from '@issuemanager/apps/client/components';
import { useIssueOutletContext } from '../../hooks/useIssueOutletContext';
import { useReassignActionOwnerRequest } from '../../hooks/use-reassign-action-owner-request';

type Props = {
  actionId: string;
  open: boolean;
  onClose: () => void;
};

function ConfirmReassignmentRequestDialog({ actionId, open, onClose }: Props) {
  const { t } = useTranslation('action');
  const { enqueueSnackbar } = useSnackbar();
  const { code } = useIssueOutletContext();

  const handleRequestSuccess = () => {
    onClose();
    enqueueSnackbar(t('manage.requestReassignment.modal.success'), {
      variant: 'success',
    });
  };

  const reassignActionRequest = useReassignActionOwnerRequest({
    actionId,
    code,
    onSuccess: handleRequestSuccess,
  });

  return (
    <ConfirmationModal
      isOpen={open}
      swapButtons
      title={t('manage.requestReassignment.modal.title')}
      description={
        <Typography variant='body1'>
          {t('manage.requestReassignment.modal.message')}
        </Typography>
      }
      acceptButtonProps={{
        text: reassignActionRequest.isPending
          ? t('manage.requestReassignment.modal.requesting')
          : t('manage.requestReassignment.modal.request'),
        loading: reassignActionRequest.isPending,
      }}
      cancelButtonProps={{
        text: t('manage.requestReassignment.modal.cancel'),
        variant: 'text',
      }}
      onAccept={reassignActionRequest.mutateAsync}
      onCancel={onClose}
    />
  );
}

export default ConfirmReassignmentRequestDialog;
